import React from 'react'
import { Main } from './components'

const CRM = () => <Main />

export default CRM
